import type { ComponentType, ReactNode, SVGProps } from 'react';

/**
 * Empty state — design-language §7, used MORE than Sonar does: every first-run
 * surface gets icon + one plain sentence + one CTA. Never a bare text row.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon: ComponentType<SVGProps<SVGSVGElement> & { size?: number }>;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center rounded-[var(--radius)] border border-dashed border-border p-6 text-center md:p-12">
      <div className="flex size-10 items-center justify-center rounded-[var(--radius)] bg-surface-2 text-muted-foreground">
        <Icon size={22} />
      </div>
      <p className="mt-3 text-lg font-medium">{title}</p>
      {description ? (
        <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
